// extracted by mini-css-extract-plugin
export default {"FolderPopup":"FolderPopup_FolderPopup__mEHr4","Frame":"FolderPopup_Frame__klYZc","swing-in":"FolderPopup_swing-in__f4fqi"};